<dx-toolbar id="header-toolbar">
  <dxi-item location="before" widget="dxButton">
    <dx-button
      (onClick)="toggleSidebar()"
      [icon]="sidebarButtonIcon"
      type="default"
    ></dx-button>
  </dxi-item>

  <dxi-item location="before">
    <div *dxTemplate>
      @if (pageTitle$ | async; as pageTitle) {
        <div class="page-title">{{ pageTitle }}</div>
      }
    </div>
  </dxi-item>

  <dxi-item location="after">
    <div *dxTemplate>
      <div class="pbx-mode-buttons">
        <div *ngFor="let pbx of pbxs" class="pbx-mode-btn"
             [id]="'pbx-mode-' + pbx.id"
             [ngClass]="{ 'pbx-mode-btn--present': pbx.pbx_mode == PbxMode.ALWAYS_PRESENT,
                          'pbx-mode-btn--absent': pbx.pbx_mode == PbxMode.ALWAYS_ABSENT }">
          <svg-icon [src]="getPbxModeIcon(pbx)"></svg-icon>
        </div>
      </div>
      <dx-popover *ngFor="let pbx of pbxs"
                  [target]="'#pbx-mode-' + pbx.id"
                  showEvent="click"
                  [hideOnOutsideClick]="true"
                  position="bottom">
        <div *dxTemplate="let data of 'content'" class="pbx-state-card"
             [ngClass]="{ 'full-on-state': pbx.pbx_mode == PbxMode.ALWAYS_PRESENT, 'off-state': pbx.pbx_mode == PbxMode.ALWAYS_ABSENT }">
          <div class="pbx-card-header">
            <div class="card-title">
              <div class="pbx-call-text-icon">
                <svg-icon class="pbx-call-icon" src="assets/icons/ic_phone_call.svg"></svg-icon>
                <p>{{ pbx.name }}</p>
              </div>
              <div class="pbx-card-state">
                <span *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_PRESENT">{{ "Pbxs.AlwaysPresentModeTitle" | i18next }}</span>
                <span *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_ABSENT">{{ "Pbxs.AlwaysAbsentModeTitle" | i18next }}</span>
              </div>
            </div>
            <div class="pbx-card-state-icon"
                 [ngClass]="{ 'pbx-card-state-icon-on': pbx.pbx_mode == PbxMode.ALWAYS_PRESENT, 'pbx-card-state-icon-off': pbx.pbx_mode == PbxMode.ALWAYS_ABSENT }">
              <svg-icon *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_PRESENT" src="assets/icons/ic_alarm.svg"></svg-icon>
              <svg-icon *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_ABSENT" src="assets/icons/ic_moon.svg"></svg-icon>
            </div>
          </div>
          <div class="pbx-state-card-text">
            <span *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_PRESENT">{{ "Pbxs.AlwaysPresentModeDescription" | i18next }}</span>
            <span *ngIf="pbx.pbx_mode == PbxMode.ALWAYS_ABSENT">{{ "Pbxs.AlwaysAbsentModeDescription" | i18next }}</span>
          </div>
          <dx-button (onClick)="togglePbxMode(pbx)" class="pbx-state-card-button" [icon]="'assets/icons/ic_settings.svg'"
                     [text]="'General.Change' | i18next" type="default" [disabled]="changingModeMap[pbx.id]"></dx-button>
          <div *ngIf="changingModeMap[pbx.id]" class="pbx-state-card__shimmer-overlay" aria-hidden="true"></div>
        </div>
      </dx-popover>
    </div>
  </dxi-item>

  <dxi-item location="after" widget="dxButton">
    <div *dxTemplate>
      <app-account-thumbnail
        [accountName]="userAttributes | username"
        id="account-item"
      ></app-account-thumbnail>
      <dx-context-menu
        id="header-context-menu"
        target="#account-item"
        [dataSource]="menuItems"
        showEvent="click"
        [width]="200"
        (onItemClick)="onContextItemClicked($event)"
      >
        <div
          *dxTemplate="let data of 'item'; let i = index"
          [ngClass]="[data.cssClass ?? '']"
        >
          <svg-icon *ngIf="data.icon" [src]="data.icon" class="menu-action-icon"></svg-icon>
                    <div>{{ data.text }}</div>
        </div>
      </dx-context-menu>
    </div>
  </dxi-item>
</dx-toolbar>

<dx-load-panel
    [visible]="loggingOut"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    shadingColor="rgba(0,0,0,0.4)"
    [container]="'body'"
    [position]="{ of: 'body' }">
</dx-load-panel>
